import { escapeHtml } from "../router.js";

/**
 * Render pagination controls for a `{page, page_size, total, has_next}` page.
 * `onPage(n)` is wired by `bindPagination(root, onPage)`.
 */
export function renderPagination(page) {
  if (!page || (page.page <= 1 && !page.has_next)) return "";
  const totalPages = page.page_size ? Math.max(1, Math.ceil((page.total || 0) / page.page_size)) : null;
  return `
    <nav class="pagination" aria-label="Paginação">
      <button type="button" class="btn btn--ghost" data-page="${page.page - 1}" ${page.page <= 1 ? "disabled" : ""}>← Anterior</button>
      <span class="pagination__info">Página ${page.page}${totalPages ? ` de ${totalPages}` : ""} · ${escapeHtml(
        (page.total ?? 0).toLocaleString("pt-BR"),
      )} itens</span>
      <button type="button" class="btn btn--ghost" data-page="${page.page + 1}" ${page.has_next ? "" : "disabled"}>Próxima →</button>
    </nav>`;
}

export function bindPagination(root, onPage) {
  root.querySelectorAll(".pagination [data-page]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const n = Number(btn.dataset.page);
      if (n >= 1) onPage(n);
    });
  });
}
